module.exports = __webpack_public_path__ + "static/heavylift-236572edc65cfc0a6a32d68eaa5ef6cc.jpg";